export { default } from './DefaultSpeedDials';